<template>
  <div>
    <div class="location">
      当前位置：
      <router-link :to="{ path: '/' }" class="a">首页</router-link
      >&nbsp;&gt;&nbsp;
      <router-link
        :to="{ path: '/weekReport', query: { uid: currentReportUid } }"
        class="a"
        >{{ currentReportUid }}</router-link
      >&nbsp;&gt;&nbsp;
      <a class="a" href="javascript:;">{{ currentFieldname }}</a>
    </div>
    <ul class="clearfix m-style">
      <li class="j_li1 fl" v-for="item in docsData" :key="item.code">
        <a
          :href="
            indexLinkURL +
            '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
            item.chnid +
            '&leafid=' +
            item.leafid +
            '&docid=' +
            item.code.substring(4, item.code.length) +
            '&uid=' +
            item.uid +
            '&version=dReport'
          "
          target="_blank"
          :title="item.title"
        >
          <div class="txtwarp h79">
            <span :title="item.title">{{ item.title }}</span>
            <!-- <p :title="item.title">{{item.title}}</p> -->
          </div>
          <div class="picwarp">
            <img
              v-if="item.code"
              :src="
                indexImgURL +
                '/www/ydyl/ImageShow.ashx?docId=' +
                item.code.substring(4, item.code.length) +
                '&purposeId=2'
              "
              class="w145"
            />
            <img v-else class="w145" />
          </div>
        </a>
        <p class="title_p">
          <a
            :href="
              indexLinkURL +
              '/eDRCnet.common.web/DocDetail.aspx?chnid=' +
              item.chnid +
              '&leafid=' +
              item.leafid +
              '&docid=' +
              item.code.substring(4, item.code.length) +
              '&uid=' +
              item.uid +
              '&version=dReport'
            "
            target="_blank"
            :title="item.title"
            >{{ item.title }}</a
          >
        </p>
      </li>
      <li
        class="j_li1 fl"
        v-if="docsData.length === 0"
        style="font-size: 20px; text-align: center; color: #0770b9"
      >
        即将推出 ！
      </li>
    </ul>
    <div class="y-pagination" v-if="windowWidth > 769">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="30"
        layout="prev, pager, next, jumper, total"
        :total="total"
      ></el-pagination>
    </div>
    <div
      class="y-pagination"
      v-if="windowWidth < 769"
      style="margin: 16px auto; width: 251px"
    >
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="30"
        :pager-count="5"
        small
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { api } from "@/pages/index/require/api.js";
export default {
  data() {
    return {
      docsData: [],
      currentReportUid: "",
      currentId: "",
      currentFieldname: "",
      total: 0,
      currentPage: 1,
      indexLinkURL: window.indexLinkURL,
      indexImgURL: window.indexImgURL,
    };
  },
  created() {
    this.currentReportUid = this.$route.query.uid;
    this.$route.query.id === undefined
      ? (this.currentId = "90")
      : (this.currentId = this.$route.query.id);
    this.currentFieldname = this.$route.query.idname;
    this.currentPage = 1;
    this.loadDocs();
  },
  watch: {
    $route() {
      this.currentReportUid = this.$route.query.uid;
      this.$route.query.id === undefined
        ? (this.currentId = "90")
        : (this.currentId = this.$route.query.id);
      this.currentFieldname = this.$route.query.idname;
      this.currentPage = 1;
      this.loadDocs();
    },
  },
  methods: {
    async loadDocs() {
      const { code, data } = await api.get("/indexController/getIndexDocs", {
        uid: this.currentId,
        reportType: this.currentReportUid,
        currpage: this.currentPage,
        pagesize: 30,
        isIndexSearch: false,
        time: new Date().getTime(),
      });
      this.docsData = [];
      this.total = 0;
      if (code === 0) {
        if (data.yearreport.data) {
          this.docsData = data.yearreport.data;
          this.total = data.yearreport.totlalCount;
        }
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadDocs();
    },
  },
};
</script>

<style lang='less' scoped>
.j_li1 {
  margin: 9px;
  a {
    display: block;
    padding: 4px;
    border: 1px solid #dfdfdf;
    color: #fff;
    width: 160px;
    transition: all 0.3s ease;
    .txtwarp {
      background: url(../../../../assets/imgs/fm_s.jpg) no-repeat;
      height: 78px;
      background-size: 100%;
      text-align: center;
      padding-top: 20px;
      p {
        font-size: 16px;
        overflow: hidden;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-top: 3px;
      }
    }
    .picwarp {
      width: 150px;
      height: 115px;
    }
  }
  .title_p {
    margin-bottom: 10px;
    height: 85px;
    a {
      text-align: center;
      color: #7f7f7f;
      margin-top: 5px;
      border: none;
    }
    a:hover {
      color: #0770b9;
    }
  }
}
.j_li1 > a:hover {
  box-shadow: 0px 0px 8px #7f7f7f;
}
img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.y-pagination {
  font-family: "microsoft yahei";
  font-size: 12px;
  margin: 30px 0;
  padding-bottom: 20px;
}
/deep/.el-pagination__jump {
  margin: 0 24px;
}
@media screen and (max-width: 769px) {
  .m-style{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>